import React, { useContext, useState } from 'react';
import { useQuery } from 'react-query';
import { Popover, List, Typography, FormInstance, Spin } from 'antd';

import TaskModal from './TaskModal';
import { getProcTaskInit } from 'services/workflow';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { PropThirdPartyResponse } from 'services/proposal';
import { isNil, noop } from 'lodash';
import { AuthContext } from 'components/Auth/Auth';
import ModalControllerNV from 'components/ModalControllerNV';
import _ from 'lodash';

export type TasksListPopoverProps = {
  tptype?: string;
  countcode?: string;
  tpid?: number;
  formTP?: FormInstance;
  mgid?: number;
  entityName: string;
  entityReference?: string;
  entityId: number;
  title?: string;
  subentity?: string;
  subentityid?: number;
  onSuccess?: any;
  children: React.ReactChild;
  dataCtr?: Array<PropThirdPartyResponse>;
  dataInput?: any;
  action?: string;
  funcode?: string;
  entityList?: Array<{ entityId: number }>;
  status?: string;
  statusdate?: string;
  requestedamount?: number;
  currcode?: string;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  clientName?: string;
  ctrid?: number;
  refetchProp?: any;
  onClose?: any;
  prcode?: string;
};

const TasksListPopover = ({
  dataCtr,
  tptype,
  countcode,
  formTP,
  mgid,
  entityId,
  entityName,
  title,
  subentity,
  subentityid,
  entityReference,
  tpid,
  onSuccess = noop,
  dataInput,
  action,
  funcode,
  entityList,
  status,
  statusdate,
  requestedamount,
  currcode,
  parcode,
  parvalue,
  parvalueparent,
  clientName,
  ctrid,
  refetchProp,
  onClose,
  prcode,
  ...otherProps
}: TasksListPopoverProps) => {
  const [visiblePopover, setVisiblePopover] = useState(false);
  const closePopover = () => setVisiblePopover(false);
  const { getComponentLabel } = useDisplayFrameworkContext();

  const { isInspect } = useContext(AuthContext);

  const { data, isLoading, isError, refetch } = useQuery(
    [
      'getProcTaskInit',
      { entityId, entityName, funcode, action, prcode },
      refetchProp,
    ],
    () =>
      getProcTaskInit({
        entity: entityName,
        entityid: entityId,
        funcode: funcode ?? '',
        action: action ?? '',
        prcode: prcode ?? '',
      }).then((res) => res.list || []),
    {
      staleTime: 3000,
      enabled: !!entityName && !isNil(entityId) && visiblePopover,
    }
  );
  const content = (
    <>
      {/* {isLoading && <Spin tip="Loading..."></Spin>} */}

      {isError && 'Failed to load tasks'}

      <Spin spinning={isLoading}>
        <List
          style={{ margin: '0px -16px' }}
          size="small"
          dataSource={data}
          pagination={{
            simple: true,
            pageSize: 5,
            position: 'bottom',
            hideOnSinglePage: true,
            responsive: true,
          }}
          renderItem={(task) => (
            <div onClick={(e) => e.stopPropagation()}>
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <List.Item
                    onClick={() => {
                      setVisible(true);
                      closePopover();
                    }}
                    style={{ textAlign: 'center' }}
                  >
                    <List.Item.Meta
                      title={
                        <Typography.Link>{task.tasklabel}</Typography.Link>
                      }
                    />
                  </List.Item>
                )}
                modal={({ setVisible, visible }) => {
                  const showModal = () => {
                    setVisible(true);
                  };

                  // Function to hide the modal
                  const hideModal = () => {
                    setVisible(false);
                  };
                  return (
                    <TaskModal
                      //setReftch={setReftch}
                      clientName={clientName}
                      entityList={entityList}
                      random={Math.round(_.random(10000) * 10000000)}
                      entityId={entityId}
                      entity={entityName}
                      entityName={
                        !isNil(title) ? entityName + ' - ' + title : entityName
                      }
                      subentity={task.subentity}
                      subentityid={task.subentityid}
                      onCancel={() => {
                        hideModal();
                        onClose();
                      }}
                      onSuccess={(e: any) => {
                        onSuccess();
                      }}
                      task={task}
                      visible={visible}
                      mgid={mgid}
                      formTP={formTP}
                      tptype={tptype}
                      countcode={countcode}
                      tpid={tpid}
                      ctrid={ctrid}
                      data={dataCtr}
                      entityReference={entityReference}
                      dataInput={dataInput}
                      status={status}
                      statusdate={statusdate}
                      requestedamount={requestedamount}
                      currcode={currcode}
                      parcode={parcode}
                      parvalue={parvalue}
                      parvalueparent={parvalueparent}
                    />
                  );
                }}
              ></ModalControllerNV>
            </div>
          )}
        />
        <Typography.Link onClick={closePopover}>
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '15px',
              textAlign: 'center',
              marginTop: '5px',
            }}
          >
            {getComponentLabel('close')}
          </div>
        </Typography.Link>
      </Spin>
    </>
  );

  return (
    <Popover
      content={content}
      title={
        <div
          style={{ fontWeight: 'bold', fontSize: '1rem', textAlign: 'center' }}
        >
          {getComponentLabel('availableActions')}
        </div>
      }
      trigger="click"
      placement="bottomRight"
      visible={visiblePopover}
      onVisibleChange={(visible) => {
        setVisiblePopover(true);
        // if (!isInspect) setVisible(true);
        if (visible === false) setVisiblePopover(false);
      }}
      overlayInnerStyle={{ width: 220 }}
      style={{ zIndex: 1060 }}
      {...otherProps}
    />
  );
};

export default TasksListPopover;
